import { FC } from "react";
import { RoutePaths } from "../../../router/config";
import { Link, useLocation } from "react-router-dom";
import classNames from "classnames";
import styles from "./Header.module.scss";

import { ReactComponent as TellIcon } from "../../../icons/tel.svg";
import LogoIcon from "../../../icons/logo.jpg";
import { phoneFormatter } from "../../../utils/telephoneMask";

interface HeaderProps {}

const Header: FC<HeaderProps> = () => {
  const { pathname } = useLocation();
  const isActiveRoute = (path: string) => pathname === path;

  return (
    <header className={styles.Header}>
      <div className={styles.flex}>
        <a className={styles.logo} href="/">
          <img src={LogoIcon} alt="logo" />
        </a>
        <div className={styles.flex__right}>
          <div className={styles.tel}>
            <TellIcon style={{ marginRight: 10 }} height={25} width={25} />
            <a href="tel:89222137555"> {phoneFormatter("89222137555")}</a>
          </div>

          <a className={styles.btn} href="mailto:kokotkina_2013@mail.ru">
            письмо на почту
          </a>
        </div>
      </div>
      <nav className={styles.nav}>
        {Object.values(RoutePaths).map(({ path, name }) => (
          <Link
            className={classNames(styles.link, {
              [styles.active]: isActiveRoute(path),
            })}
            to={path}
            key={path}
          >
            {name}
          </Link>
        ))}
      </nav>
    </header>
  );
};

export default Header;
